class DeliveryTimer {
  constructor(config) {
    this.cutOffTime = config.cutOffTime;
    this.processingDays = config.processingDays;
    this.text = config.text;
    
    this.excludedDays = this.processExcludedDays(config.excludeDays);
  }

  processExcludedDays(excludeDays) {
    const excludedDayNumbers = [];
    const dayMapping = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6
    };

    Object.entries(excludeDays).forEach(([day, isExcluded]) => {
      if (isExcluded && dayMapping.hasOwnProperty(day.toLowerCase())) {
        excludedDayNumbers.push(dayMapping[day.toLowerCase()]);
      }
    });

    return excludedDayNumbers;
  }

  init() {
    this.updateTimer();
    setInterval(() => this.updateTimer(), 1000);
  }

  convertTo24Hour(time12h) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    
    if (hours === '12') {
      hours = '00';
    }
    
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    
    return `${hours}:${minutes}`;
  }

  isExcludedDay(date) {
    return this.excludedDays.includes(date.getDay());
  }

  getNextDeliveryDate(currentDate) {
    let deliveryDate = new Date(currentDate);
    deliveryDate.setDate(deliveryDate.getDate() + this.processingDays);
    
    while (this.excludedDays.includes(deliveryDate.getDay())) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
    
    return deliveryDate;
  }

  getNextWorkingDay(currentDate) {
    let nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);
    
    while (this.isExcludedDay(nextDay)) {
      nextDay.setDate(nextDay.getDate() + 1);
    }
    
    return nextDay;
  }

  isPastCutoff(currentDate) {
    const time24 = this.convertTo24Hour(this.cutOffTime);
    const [cutoffHour, cutoffMinute] = time24.split(':').map(Number);
    return currentDate.getHours() > cutoffHour || 
           (currentDate.getHours() === cutoffHour && currentDate.getMinutes() >= cutoffMinute);
  }

  formatTimeRemaining(timeRemaining) {
    const hours = Math.floor(timeRemaining / 3600000);
    const minutes = Math.floor((timeRemaining % 3600000) / 60000);
    
    let formattedTime = '';
    if (hours > 0) {
      formattedTime += `${hours} ${this.text.hoursText} `;
    }
    formattedTime += `${minutes} ${this.text.minutesText}`;
    
    return formattedTime;
  }

  toggleTimerVisibility(show) {
    const timerElement = document.getElementById('delivery-timer');
    timerElement.style.display = show ? 'block' : 'none';
  }

  updateTimer() {
    const now = new Date();
    
    if (this.isExcludedDay(now)) {
      this.toggleTimerVisibility(false);
      return;
    }

    const time24 = this.convertTo24Hour(this.cutOffTime);
    const [cutoffHour, cutoffMinute] = time24.split(':').map(Number);
    
    let targetDate = new Date(now);
    targetDate.setHours(cutoffHour, cutoffMinute, 0, 0);

    let deliveryDate;
    if (this.isPastCutoff(now)) {
      targetDate = this.getNextWorkingDay(now);
      targetDate.setHours(cutoffHour, cutoffMinute, 0, 0);
      deliveryDate = this.getNextDeliveryDate(targetDate);
      this.toggleTimerVisibility(true);
    } else {
      deliveryDate = this.getNextDeliveryDate(targetDate);
      this.toggleTimerVisibility(true);
    }

    const timeRemaining = targetDate - now;
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    
    // Check if delivery date is tomorrow
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isDeliveryTomorrow = deliveryDate.getDate() === tomorrow.getDate() &&
                              deliveryDate.getMonth() === tomorrow.getMonth() &&
                              deliveryDate.getFullYear() === tomorrow.getFullYear();
    
    // Function to add ordinal suffix to day
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    // Format the delivery date
    const day = deliveryDate.getDate();
    const month = deliveryDate.toLocaleDateString('en-US', { month: 'long' });
    const ordinalDay = `${day}${getOrdinalSuffix(day)}`;
    const deliveryDayText = isDeliveryTomorrow 
      ? 'Tomorrow'
      : `${dayNames[deliveryDate.getDay()]}, ${ordinalDay} ${month}`;
    
    document.getElementById('delivery-prefix').textContent = this.text.getItBy;
    document.getElementById('delivery-day-text').textContent = deliveryDayText;
    document.getElementById('order-prefix').textContent = this.text.orderWithin;
    document.getElementById('countdown-timer').textContent = this.formatTimeRemaining(timeRemaining);
  }
}

// Initialize timer when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {  
  if (typeof deliveryTimerConfig !== 'undefined') {
    const timer = new DeliveryTimer(deliveryTimerConfig);
    timer.init();
  }
});